import React from 'react';
import { TextField } from 'react-admin';

import { List, Datagrid } from 'components/list';
import { ActionField } from 'components/fields';
import EditTierField from './components/EditTierField';

const AchTiersList = (props) => {
  return (
    <List pagination={null} {...props}>
      <Datagrid rowClick="show">
        <TextField source="tier" label="Tier #" />
        <TextField source="instantAvailabilityCapCents" label="Instant availability cap" />
        <TextField source="minSuccessfulClearancesToPromote" label="Min successful clearances" />
        <TextField source="minDynamicCapCents" label="Min dynamic cap" />
        <TextField source="maxDynamicCapCents" label="Max dynamic cap" />

        <ActionField>
          <EditTierField />
          {/* <DeleteLevelActionField /> */}
        </ActionField>
      </Datagrid>
    </List>
  );
};

export default AchTiersList;
